
import * as ActionTypes from './actionTypes'

export function initializeFormValues(newValue,setINPUTID,penClicked,fieldName,rbCounterID) {
    return {
        type: ActionTypes.FORM_VALUES,
        newValue,
        setINPUTID,
        penClicked,
        fieldName,
        rbCounterID
    }
}
export function initializeShipmentNotes(payload, notesLoaded) {
    return {
      type: ActionTypes.INITIALIZE_VALUES_NOTES,
      payload,
      notesLoaded,
    }
  }

export function setErrorMessage(
    errorMessage
) {
    return {
        type: ActionTypes.SET_ERROR_MESSAGE,
        errorMessage
    }
}